"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var DateTimeFormatterI18n = /*#__PURE__*/function () {
  function DateTimeFormatterI18n(_ref) {
    var i18nize = _ref.i18nize,
        maps = _ref.maps,
        timeZones = _ref.timeZones,
        getShortWeekdayKey = _ref.getShortWeekdayKey,
        getLongWeekdayKey = _ref.getLongWeekdayKey,
        getShortMonthKey = _ref.getShortMonthKey,
        getLongMonthKey = _ref.getLongMonthKey,
        getTimeZoneKey = _ref.getTimeZoneKey;
    (0, _classCallCheck2["default"])(this, DateTimeFormatterI18n);
    this.i18nize = i18nize;
    this.maps = maps;
    this.timeZones = timeZones;
    this.getShortWeekdayKey = getShortWeekdayKey;
    this.getLongWeekdayKey = getLongWeekdayKey;
    this.getShortMonthKey = getShortMonthKey;
    this.getLongMonthKey = getLongMonthKey;
    this.getTimeZoneKey = getTimeZoneKey;
  }

  (0, _createClass2["default"])(DateTimeFormatterI18n, [{
    key: "build",
    value: function build() {
      return {
        weekdays: this.getLongShort({
          map: this.maps.weekdays,
          getLongKey: this.getLongWeekdayKey,
          getShortKey: this.getShortWeekdayKey
        }),
        months: this.getLongShort({
          map: this.maps.months,
          getLongKey: this.getLongMonthKey,
          getShortKey: this.getShortMonthKey
        }),
        timeZones: this.getTimeZones()
      };
    }
  }, {
    key: "getLongShort",
    value: function getLongShort(_ref2) {
      var _this = this;

      var map = _ref2.map,
          getLongKey = _ref2.getLongKey,
          getShortKey = _ref2.getShortKey;
      var _long = {};
      var _short = {};
      Object.keys(map).forEach(function (number) {
        var key = map[number];
        _long[number] = _this.i18nize(getLongKey(key));
        _short[number] = _this.i18nize(getShortKey(key));
      });
      return {
        "long": _long,
        "short": _short
      };
    }
  }, {
    key: "getTimeZones",
    value: function getTimeZones() {
      var _this2 = this;

      return this.timeZones.reduce(function (hash, timeZone) {
        hash[timeZone] = _this2.i18nize(_this2.getTimeZoneKey(timeZone));
        return hash;
      }, {});
    }
  }]);
  return DateTimeFormatterI18n;
}();

var getDateTimeFormatterI18n = function getDateTimeFormatterI18n(args) {
  return new DateTimeFormatterI18n(args).build();
};

var _default = getDateTimeFormatterI18n;
exports["default"] = _default;